// Gerado por scripts/gen-map-names.mjs — não editar à mão.
// Índices: MAP_NAMES[mapGroup][mapNum]

export const MAP_NAMES: readonly (readonly string[])[] = [
  [
    "Battle Colosseum · 2P",
    "Trade Center",
    "Record Corner",
    "Battle Colosseum · 4P",
    "Union Room"
  ],
  [
    "Viridian Forest",
    "Mt Moon · 1F",
    "Mt Moon · B1F",
    "Mt Moon · B2F",
    "SS Anne · Exterior",
    "SS Anne · 1F · Corridor",
    "SS Anne · 2F · Corridor",
    "SS Anne · 3F · Corridor",
    "SS Anne · B1F · Corridor",
    "SS Anne · Deck",
    "SS Anne · Kitchen",
    "SS Anne · Captains Office",
    "SS Anne · 1F · Room 1",
    "SS Anne · 1F · Room 2",
    "SS Anne · 1F · Room 3",
    "SS Anne · 1F · Room 4",
    "SS Anne · 1F · Room 5",
    "SS Anne · 1F · Room 7",
    "SS Anne · 2F · Room 1",
    "SS Anne · 2F · Room 2",
    "SS Anne · 2F · Room 3",
    "SS Anne · 2F · Room 4",
    "SS Anne · 2F · Room 5",
    "SS Anne · 2F · Room 6",
    "SS Anne · B1F · Room 1",
    "SS Anne · B1F · Room 2",
    "SS Anne · B1F · Room 3",
    "SS Anne · B1F · Room 4",
    "SS Anne · B1F · Room 5",
    "SS Anne · 1F · Room 6",
    "Underground Path · North Entrance",
    "Underground Path · North South Tunnel",
    "Underground Path · South Entrance",
    "Underground Path · West Entrance",
    "Underground Path · East West Tunnel",
    "Underground Path · East Entrance",
    "Digletts Cave · North Entrance",
    "Digletts Cave · B1F",
    "Digletts Cave · South Entrance",
    "Victory Road · 1F",
    "Victory Road · 2F",
    "Victory Road · 3F",
    "Rocket Hideout · B1F",
    "Rocket Hideout · B2F",
    "Rocket Hideout · B3F",
    "Rocket Hideout · B4F",
    "Rocket Hideout · Elevator",
    "Silph Co · 1F",
    "Silph Co · 2F",
    "Silph Co · 3F",
    "Silph Co · 4F",
    "Silph Co · 5F",
    "Silph Co · 6F",
    "Silph Co · 7F",
    "Silph Co · 8F",
    "Silph Co · 9F",
    "Silph Co · 10F",
    "Silph Co · 11F",
    "Silph Co · Elevator",
    "Pokemon Mansion · 1F",
    "Pokemon Mansion · 2F",
    "Pokemon Mansion · 3F",
    "Pokemon Mansion · B1F",
    "Safari Zone · Center",
    "Safari Zone · East",
    "Safari Zone · North",
    "Safari Zone · West",
    "Safari Zone · Center · Rest House",
    "Safari Zone · East · Rest House",
    "Safari Zone · North · Rest House",
    "Safari Zone · West · Rest House",
    "Safari Zone · Secret House",
    "Cerulean Cave · 1F",
    "Cerulean Cave · 2F",
    "Cerulean Cave · B1F",
    "Pokemon League · Loreleis Room",
    "Pokemon League · Brunos Room",
    "Pokemon League · Agathas Room",
    "Pokemon League · Lances Room",
    "Pokemon League · Champions Room",
    "Pokemon League · Hall Of Fame",
    "Rock Tunnel · 1F",
    "Rock Tunnel · B1F",
    "Seafoam Islands · 1F",
    "Seafoam Islands · B1F",
    "Seafoam Islands · B2F",
    "Seafoam Islands · B3F",
    "Seafoam Islands · B4F",
    "Pokemon Tower · 1F",
    "Pokemon Tower · 2F",
    "Pokemon Tower · 3F",
    "Pokemon Tower · 4F",
    "Pokemon Tower · 5F",
    "Pokemon Tower · 6F",
    "Pokemon Tower · 7F",
    "Power Plant",
    "Mt Ember · Ruby Path · B4F",
    "Mt Ember · Exterior",
    "Mt Ember · Summit Path · 1F",
    "Mt Ember · Summit Path · 2F",
    "Mt Ember · Summit Path · 3F",
    "Mt Ember · Summit",
    "Mt Ember · Ruby Path · B5F",
    "Mt Ember · Ruby Path · 1F",
    "Mt Ember · Ruby Path · B1F",
    "Mt Ember · Ruby Path · B2F",
    "Mt Ember · Ruby Path · B3F",
    "Mt Ember · Ruby Path · B1F · Stairs",
    "Mt Ember · Ruby Path · B2F · Stairs",
    "Three Island · Berry Forest",
    "Four Island · Icefall Cave · Entrance",
    "Four Island · Icefall Cave · 1F",
    "Four Island · Icefall Cave · B1F",
    "Four Island · Icefall Cave · Back",
    "Five Island · Rocket Warehouse",
    "Six Island · Dotted Hole · 1F",
    "Six Island · Dotted Hole · B1F",
    "Six Island · Dotted Hole · B2F",
    "Six Island · Dotted Hole · B3F",
    "Six Island · Dotted Hole · B4F",
    "Six Island · Dotted Hole · Sapphire Room",
    "Six Island · Pattern Bush",
    "Six Island · Altering Cave"
  ],
  [
    "Navel Rock · Exterior",
    "Trainer Tower · 1F",
    "Trainer Tower · 2F",
    "Trainer Tower · 3F",
    "Trainer Tower · 4F",
    "Trainer Tower · 5F",
    "Trainer Tower · 6F",
    "Trainer Tower · 7F",
    "Trainer Tower · 8F",
    "Trainer Tower · Roof",
    "Trainer Tower · Lobby",
    "Trainer Tower · Elevator",
    "Five Island · Lost Cave · Entrance",
    "Five Island · Lost Cave · Room 1",
    "Five Island · Lost Cave · Room 2",
    "Five Island · Lost Cave · Room 3",
    "Five Island · Lost Cave · Room 4",
    "Five Island · Lost Cave · Room 5",
    "Five Island · Lost Cave · Room 6",
    "Five Island · Lost Cave · Room 7",
    "Five Island · Lost Cave · Room 8",
    "Five Island · Lost Cave · Room 9",
    "Five Island · Lost Cave · Room 10",
    "Five Island · Lost Cave · Room 11",
    "Five Island · Lost Cave · Room 12",
    "Five Island · Lost Cave · Room 13",
    "Five Island · Lost Cave · Room 14",
    "Seven Island · Tanoby Ruins · Monean Chamber",
    "Seven Island · Tanoby Ruins · Liptoo Chamber",
    "Seven Island · Tanoby Ruins · Weepth Chamber",
    "Seven Island · Tanoby Ruins · Dilford Chamber",
    "Seven Island · Tanoby Ruins · Scufib Chamber",
    "Seven Island · Tanoby Ruins · Rixy Chamber",
    "Seven Island · Tanoby Ruins · Viapois Chamber",
    "Three Island · Dunsparce Tunnel",
    "Seven Island · Sevault Canyon · Tanoby Key",
    "Navel Rock · 1F",
    "Navel Rock · Summit",
    "Navel Rock · Base",
    "Navel Rock · Summit Path · 2F",
    "Navel Rock · Summit Path · 3F",
    "Navel Rock · Summit Path · 4F",
    "Navel Rock · Summit Path · 5F",
    "Navel Rock · Base Path · B1F",
    "Navel Rock · Base Path · B2F",
    "Navel Rock · Base Path · B3F",
    "Navel Rock · Base Path · B4F",
    "Navel Rock · Base Path · B5F",
    "Navel Rock · Base Path · B6F",
    "Navel Rock · Base Path · B7F",
    "Navel Rock · Base Path · B8F",
    "Navel Rock · Base Path · B9F",
    "Navel Rock · Base Path · B10F",
    "Navel Rock · Base Path · B11F",
    "Navel Rock · B1F",
    "Navel Rock · Fork",
    "Birth Island · Exterior",
    "One Island · Kindle Road · Ember Spa",
    "Birth Island · Harbor",
    "Navel Rock · Harbor"
  ],
  [
    "Pallet Town",
    "Viridian City",
    "Pewter City",
    "Cerulean City",
    "Lavender Town",
    "Vermilion City",
    "Celadon City",
    "Fuchsia City",
    "Cinnabar Island",
    "Indigo Plateau · Exterior",
    "Saffron City",
    "Saffron City · Connection",
    "One Island",
    "Two Island",
    "Three Island",
    "Four Island",
    "Five Island",
    "Seven Island",
    "Six Island",
    "Route 1",
    "Route 2",
    "Route 3",
    "Route 4",
    "Route 5",
    "Route 6",
    "Route 7",
    "Route 8",
    "Route 9",
    "Route 10",
    "Route 11",
    "Route 12",
    "Route 13",
    "Route 14",
    "Route 15",
    "Route 16",
    "Route 17",
    "Route 18",
    "Route 19",
    "Route 20",
    "Route 21 · North",
    "Route 21 · South",
    "Route 22",
    "Route 23",
    "Route 24",
    "Route 25",
    "One Island · Kindle Road",
    "One Island · Treasure Beach",
    "Two Island · Cape Brink",
    "Three Island · Bond Bridge",
    "Three Island · Port",
    "Prototype · Sevii Isle · 6",
    "Prototype · Sevii Isle · 7",
    "Prototype · Sevii Isle · 8",
    "Prototype · Sevii Isle · 9",
    "Five Island · Resort Gorgeous",
    "Five Island · Water Labyrinth",
    "Five Island · Meadow",
    "Five Island · Memorial Pillar",
    "Six Island · Outcast Island",
    "Six Island · Green Path",
    "Six Island · Water Path",
    "Six Island · Ruin Valley",
    "Seven Island · Trainer Tower",
    "Seven Island · Sevault Canyon · Entrance",
    "Seven Island · Sevault Canyon",
    "Seven Island · Tanoby Ruins"
  ],
  [
    "Pallet Town · Players House · 1F",
    "Pallet Town · Players House · 2F",
    "Pallet Town · Rivals House",
    "Pallet Town · Professor Oaks Lab"
  ],
  [
    "Viridian City · House",
    "Viridian City · Gym",
    "Viridian City · School",
    "Viridian City · Mart",
    "Viridian City · Pokemon Center · 1F",
    "Viridian City · Pokemon Center · 2F"
  ],
  [
    "Pewter City · Museum · 1F",
    "Pewter City · Museum · 2F",
    "Pewter City · Gym",
    "Pewter City · Mart",
    "Pewter City · House 1",
    "Pewter City · Pokemon Center · 1F",
    "Pewter City · Pokemon Center · 2F",
    "Pewter City · House 2"
  ],
  [
    "Cerulean City · House 1",
    "Cerulean City · House 2",
    "Cerulean City · House 3",
    "Cerulean City · Pokemon Center · 1F",
    "Cerulean City · Pokemon Center · 2F",
    "Cerulean City · Gym",
    "Cerulean City · Bike Shop",
    "Cerulean City · Mart",
    "Cerulean City · House 4",
    "Cerulean City · House 5"
  ],
  [
    "Lavender Town · Pokemon Center · 1F",
    "Lavender Town · Pokemon Center · 2F",
    "Lavender Town · Volunteer Pokemon House",
    "Lavender Town · House 1",
    "Lavender Town · House 2",
    "Lavender Town · Mart"
  ],
  [
    "Vermilion City · House 1",
    "Vermilion City · Pokemon Center · 1F",
    "Vermilion City · Pokemon Center · 2F",
    "Vermilion City · Pokemon Fan Club",
    "Vermilion City · House 2",
    "Vermilion City · Mart",
    "Vermilion City · Gym",
    "Vermilion City · House 3"
  ],
  [
    "Celadon City · Department Store · 1F",
    "Celadon City · Department Store · 2F",
    "Celadon City · Department Store · 3F",
    "Celadon City · Department Store · 4F",
    "Celadon City · Department Store · 5F",
    "Celadon City · Department Store · Roof",
    "Celadon City · Department Store · Elevator",
    "Celadon City · Condominiums · 1F",
    "Celadon City · Condominiums · 2F",
    "Celadon City · Condominiums · 3F",
    "Celadon City · Condominiums · Roof",
    "Celadon City · Condominiums · Roof Room",
    "Celadon City · Pokemon Center · 1F",
    "Celadon City · Pokemon Center · 2F",
    "Celadon City · Game Corner",
    "Celadon City · Game Corner · Prize Room",
    "Celadon City · Gym",
    "Celadon City · Restaurant",
    "Celadon City · House 1",
    "Celadon City · Hotel"
  ],
  [
    "Fuchsia City · Safari Zone · Entrance",
    "Fuchsia City · Mart",
    "Fuchsia City · Safari Zone · Office",
    "Fuchsia City · Gym",
    "Fuchsia City · House 1",
    "Fuchsia City · Pokemon Center · 1F",
    "Fuchsia City · Pokemon Center · 2F",
    "Fuchsia City · Wardens House",
    "Fuchsia City · House 2",
    "Fuchsia City · House 3"
  ],
  [
    "Cinnabar Island · Gym",
    "Cinnabar Island · Pokemon Lab · Entrance",
    "Cinnabar Island · Pokemon Lab · Lounge",
    "Cinnabar Island · Pokemon Lab · Research Room",
    "Cinnabar Island · Pokemon Lab · Experiment Room",
    "Cinnabar Island · Pokemon Center · 1F",
    "Cinnabar Island · Pokemon Center · 2F",
    "Cinnabar Island · Mart"
  ],
  [
    "Indigo Plateau · Pokemon Center · 1F",
    "Indigo Plateau · Pokemon Center · 2F"
  ],
  [
    "Saffron City · Copycats House · 1F",
    "Saffron City · Copycats House · 2F",
    "Saffron City · Dojo",
    "Saffron City · Gym",
    "Saffron City · House",
    "Saffron City · Mart",
    "Saffron City · Pokemon Center · 1F",
    "Saffron City · Pokemon Center · 2F",
    "Saffron City · Mr Psychics House",
    "Saffron City · Pokemon Trainer Fan Club"
  ],
  [
    "Route 2 · Viridian Forest · South Entrance",
    "Route 2 · House",
    "Route 2 · East Building",
    "Route 2 · Viridian Forest · North Entrance"
  ],
  [
    "Route 4 · Pokemon Center · 1F",
    "Route 4 · Pokemon Center · 2F"
  ],
  [
    "Route 5 · Pokemon Day Care",
    "Route 5 · South Entrance"
  ],
  [
    "Route 6 · North Entrance",
    "Route 6 · Unused House"
  ],
  [
    "Route 7 · East Entrance"
  ],
  [
    "Route 8 · West Entrance"
  ],
  [
    "Route 10 · Pokemon Center · 1F",
    "Route 10 · Pokemon Center · 2F"
  ],
  [
    "Route 11 · East Entrance · 1F",
    "Route 11 · East Entrance · 2F"
  ],
  [
    "Route 12 · North Entrance · 1F",
    "Route 12 · North Entrance · 2F",
    "Route 12 · Fishing House"
  ],
  [
    "Route 15 · West Entrance · 1F",
    "Route 15 · West Entrance · 2F"
  ],
  [
    "Route 16 · House",
    "Route 16 · North Entrance · 1F",
    "Route 16 · North Entrance · 2F"
  ],
  [
    "Route 18 · East Entrance · 1F",
    "Route 18 · East Entrance · 2F"
  ],
  [
    "Route 19 · Unused House"
  ],
  [
    "Route 22 · North Entrance"
  ],
  [
    "Route 23 · Unused House"
  ],
  [
    "Route 25 · Sea Cottage"
  ],
  [
    "Seven Island · House · Room 1",
    "Seven Island · House · Room 2",
    "Seven Island · Mart",
    "Seven Island · Pokemon Center · 1F",
    "Seven Island · Pokemon Center · 2F",
    "Seven Island · Unused House",
    "Seven Island · Harbor"
  ],
  [
    "One Island · Pokemon Center · 1F",
    "One Island · Pokemon Center · 2F",
    "One Island · House 1",
    "One Island · House 2",
    "One Island · Harbor"
  ],
  [
    "Two Island · Joyful Game Corner",
    "Two Island · House",
    "Two Island · Pokemon Center · 1F",
    "Two Island · Pokemon Center · 2F",
    "Two Island · Harbor"
  ],
  [
    "Three Island · House 1",
    "Three Island · Pokemon Center · 1F",
    "Three Island · Pokemon Center · 2F",
    "Three Island · Mart",
    "Three Island · House 2",
    "Three Island · House 3",
    "Three Island · House 4",
    "Three Island · House 5"
  ],
  [
    "Four Island · Pokemon Day Care",
    "Four Island · Pokemon Center · 1F",
    "Four Island · Pokemon Center · 2F",
    "Four Island · House 1",
    "Four Island · Loreleis House",
    "Four Island · Harbor",
    "Four Island · House 2",
    "Four Island · Mart"
  ],
  [
    "Five Island · Pokemon Center · 1F",
    "Five Island · Pokemon Center · 2F",
    "Five Island · Harbor",
    "Five Island · House 1",
    "Five Island · House 2"
  ],
  [
    "Six Island · Pokemon Center · 1F",
    "Six Island · Pokemon Center · 2F",
    "Six Island · Harbor",
    "Six Island · House",
    "Six Island · Mart"
  ],
  [
    "Three Island · Harbor"
  ],
  [
    "Five Island · Resort Gorgeous · House"
  ],
  [
    "Two Island · Cape Brink · House"
  ],
  [
    "Six Island · Water Path · House 1",
    "Six Island · Water Path · House 2"
  ],
  [
    "Seven Island · Sevault Canyon · House"
  ]
];

export function mapName(group: number, num: number): string {
  return MAP_NAMES[group]?.[num] ?? `Mapa ${group}.${num}`;
}
